import React, { ReactNode } from "react";
import { motion } from "framer-motion";
import { AppHeader } from "@/components/AppHeader";

const IMG = "https://images.unsplash.com/photo-1763231575952-98244918f99b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export const AuthLayout = ({ title, sub, children }: { title: string; sub: string; children: ReactNode }) => (
  <div className="min-h-screen bg-background">
    <AppHeader />
    <div className="mx-auto max-w-6xl px-4 py-6 grid md:grid-cols-2 gap-8 items-center">
      <div className="relative hidden md:block h-[560px] rounded-[2rem] overflow-hidden">
        <img src={IMG} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-primary/70 to-transparent" />
      </div>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md mx-auto space-y-6">
        <div className="space-y-2">
          <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight">{title}</h1>
          <p className="text-muted-foreground">{sub}</p>
        </div>
        {children}
      </motion.div>
    </div>
  </div>
);
